import { createSelector } from "reselect";
import { getCurrentSale } from "./currentSale";
import { getLabels, getMasterLabels, getSaleLots } from "./root";

interface MasterLabelLookup {
  [id: string]: MasterLabel;
}
interface DeploymentLabelLookup {
  [id: string]: DeploymentLabel;
}
interface SaleLotLookup {
  [id: string]: SaleLot;
}

export const getLabelsBySpecies = createSelector(
  [getLabels, getCurrentSale, getMasterLabels],
  (labels: DeploymentLabelLookup, sale, masterLabels: MasterLabelLookup) =>
    Object.values(labels)
      .filter(p => p.species_id === sale.species_id && !p.deleted)
      .map(l => ({
        ...l,
        masterLabel: masterLabels[l.master_label_id],
      })),
);

export const getMasterLabelsBySpecies = createSelector(
  [getCurrentSale, getMasterLabels],
  (sale, masterLabels: MasterLabelLookup) =>
    Object.values(masterLabels).filter(ml => ml.speciesId === sale.species_id),
);

export const selectMasterLabelsBySaleLotId = createSelector(
  [getSaleLots, getLabels],
  (saleLots: SaleLotLookup, labels: DeploymentLabelLookup) => {
    const deploymentLabelIdToMasterLabelIdLookup = {};
    Object.values(labels).forEach(l => {
      if (l.master_label_id) {
        deploymentLabelIdToMasterLabelIdLookup[l.id] = l.master_label_id;
      }
    });
    const masterLabelIdsBySaleLotIdLookup = {};
    Object.values(saleLots).forEach(sl => {
      if (!masterLabelIdsBySaleLotIdLookup[sl.id]) {
        masterLabelIdsBySaleLotIdLookup[sl.id] = new Set();
      }
      sl.labels.forEach(l => {
        if (deploymentLabelIdToMasterLabelIdLookup[l]) {
          masterLabelIdsBySaleLotIdLookup[sl.id].add(
            deploymentLabelIdToMasterLabelIdLookup[l],
          );
        }
      });
    });
    return masterLabelIdsBySaleLotIdLookup;
  },
);

export const getLabelById =
  (labelId: string) =>
  (state: State): Label | null =>
    getLabels(state)[labelId] || null;
